import React, { useRef, useEffect } from "react";
import { Text, View, Animated, StyleSheet } from "react-native";
import Image from "@components/common/Image";
import Svg, { Circle, Defs, G, LinearGradient, Stop } from "react-native-svg";
import metrics from "../../constants/metrics";

const AnimatedCircle = Animated.createAnimatedComponent(Circle);

const Stat = (props) => {
  const { percentage, afterClickPercentage } = props;
  const width = 100;
  const circumference = 2 * Math.PI * (width / 2);
  const strokeWidth = 10;
  const radius = width / 2;
  const halfCircle = radius + strokeWidth;

  const circleRef = useRef();
  const animatedValue = useRef(new Animated.Value(0)).current;

  const animation = (toValue) =>
    Animated.timing(animatedValue, {
      toValue,
      duration: 800,
      delay: 0,
      useNativeDriver: true,
    }).start(() => {
      animatedValue.removeAllListeners();
    });

  useEffect(() => {
    animation(percentage);
    animatedValue.addListener(({ value }) => {
      if (circleRef?.current) {
        const maxPerc = Math.min((100 * value) / 100, 100);
        const strokeDashoffset =
          circumference - (circumference * maxPerc) / 100;
        circleRef.current.setNativeProps({
          strokeDashoffset,
        });
      }
    });
    () => animatedValue.removeAllListeners();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [percentage]);

  return (
    <>
      <View
        style={{
          borderRadius: 10,
          overflow: "visible",
        }}
      >
        <Svg
          height={width}
          width={width}
          viewBox={`0 0 ${halfCircle * 2} ${halfCircle * 2}`}
        >
          <Defs>
            <LinearGradient
              id="prefix__a"
              gradientUnits="userSpaceOnUse"
              x1={88}
              y1={0}
              x2={88}
              y2={176}
            >
              <Stop offset={0} stopColor="rgba(0, 171, 89, 1)" />
              <Stop offset={1} stopColor="rgba(0, 171, 89, 1)" />
            </LinearGradient>
          </Defs>
          <G rotation="-90" origin={`${halfCircle}, ${halfCircle}`}>
            <Circle
              cx="50%"
              cy="50%"
              strokeWidth={strokeWidth}
              stroke="rgba(0, 171, 89, 0.1)"
              r={radius}
              fill="transparent"
              strokeOpacity={0.5}
            />
            <AnimatedCircle
              fill="#fff"
              ref={circleRef}
              cx="50%"
              cy="50%"
              strokeWidth={strokeWidth}
              stroke="url(#prefix__a)"
              r={radius}
              strokeDasharray={circumference}
              strokeDashoffset={circumference}
              strokeLinecap="butt"
            />
          </G>
        </Svg>

        <View
          style={{
            width,
            height: width,
            justifyContent: "center",
            position: "absolute",
            alignItems: "center",
          }}
        >
          <Image
            source={{
              uri: "https://public-cdn.citymall.live/cm-admin-storage-public/cl_app_icon%2F1665576676772-Group%203252.png",
            }}
            style={[styles.shopImage, { opacity: afterClickPercentage / 100 }]}
          />
        </View>
      </View>
    </>
  );
};

export default Stat;

const styles = StyleSheet.create({
  shopImage: {
    height: 45,
    width: 45,
    opacity: 0.1,
  },
});
